import { render, staticRenderFns } from "./Pins4Id.vue?vue&type=template&id=7c802905&scoped=true&"
import script from "./Pins4Id.vue?vue&type=script&lang=js&"
export * from "./Pins4Id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c802905",
  null
  
)

export default component.exports